import { ButtonProps } from 'primereact/button';
import { classNames } from 'primereact/utils';

export const SimeraDesignSystem = {
  button: {
    root: ({ props }: { props: ButtonProps }) => ({
      className: classNames(
        'text-sm font-bold shadow-none justify-center overflow-visible rounded-full h-fit',
        {
          'text-spk-brightBlue  bg-spk-softBlue border-none hover:bg-spk-softBlue-110':
            props.severity === 'secondary' &&
            !props.text &&
            !props.outlined &&
            !props.plain,
          'text-spk-softBlue bg-spk-brightBlue  border-none hover:bg-spk-brightBlue110':
            props.severity === 'success' &&
            !props.text &&
            !props.outlined &&
            !props.plain,
          'text-neutral-0 bg-spk-hotPink border-none hover:bg-hotPink110':
            props.severity === 'contrast' &&
            !props.text &&
            !props.outlined &&
            !props.plain,
        },
        {
          'text-spk-brightBlue  border border-spk-softBlue ':
            props.outlined && props.severity === 'success' && !props.plain,
          'text-spk-mediumContrast border-spk-neutral-40 ':
            props.outlined && props.severity === 'secondary' && !props.plain,
        },
        {
          'text-spk-brightBlue ':
            props.text &&
            props.severity === 'success' &&
            !props.outlined &&
            !props.plain,
          'text-spk-mediumContrast':
            props.text &&
            props.severity === 'secondary' &&
            !props.outlined &&
            !props.plain,
        },
        {
          'text-spk-brightBlue  bg-spk-neutral-0':
            !props.text &&
            props.link &&
            props.severity === 'success' &&
            !props.outlined &&
            !props.plain,
        },
        {
          'px-4 py-2 text-xs': props.size === 'small',
          'px-5 py-3': props.size !== 'small',
        }
      ),
    }),
  },
  IconField: {
    root: {
      className: 'bg-transparent',
    },
  },
  inputicon: {
    root: {
      className: 'text-spk-mediumContrast',
    },
  },
  inputtext: {
    root: {
      className: classNames(
        'py-3 rounded-md bg-spk-neutral-0  text-spk-highContrast text-sm  focus:border-spk-hotPink hover:border-spk-hotPink enabled:focus:shadow-[0_0_0_3px_rgba(243,122,216,0.12)]',
        'font-semibold placeholder:font-normal border-spk-neutral-40 placeholder:text-spk-mediumContrast'
      ),
    },
  },
  divider: {
    root: {
      className: 'before:content-[""] before:border-spk-neutral-40',
    },
    content: {
      className:
        'bg-spk-neutral-20 text-sm font-semibold text-spk-mediumContrast',
    },
  },
  floatlabel: {
    root: {
      className: classNames(
        '[&>input]:font-normal',
        '[&>input:focus]:border-internal-main [&>input:focus:enabled]:shadow-none',
        '[&>input:hover]:border-internal-main',
        '[&>input.p-invalid]:border-red-500',
        '[&>input.p-invalid:hover]:border-red-600',
        '[&>input.p-invalid:focus]:border-red-700',
        '[&>input:focus:enabled]:shadow-none'
      ),
    },
  },
  calendar: {
    root: {
      className: classNames(
        '[&>input]:font-normal',
        '[&>input:focus]:border-internal-main [&>input:focus:enabled]:shadow-none',
        '[&>input:hover]:border-internal-main [&>input:hover:enabled]:shadow-none'
      ),
    },
  },
  tabpanel: {
    headerAction: ({ parent, context }: any) => ({
      className: classNames({
        'bg-white border-internal-main text-internal-main':
          parent != null ? parent.state.activeIndex === context.index : false, // Condition-based active styles.
      }),
    }),
  },
};
